
// Componente de teste para verificar se o roteamento está funcionando
const TestCallback = () => {
  
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#00ff00',
      color: '#000000',
      fontSize: '24px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <h1>🧪 TESTE DE ROTA FUNCIONANDO</h1>
    </div>
  );
};

export default TestCallback;
